import React  from 'react';
import './App.css';
import './Report.css';
import ReportLang from './ReportLang.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTooltip from 'react-tooltip';
import { makeLoginRequest, getStanjeXml, combineArrays } from "./adriaHelpers.js";
import { IoMdRefresh } from "react-icons/io";
import { ReportAdriaExcelHelpers } from './ReportAdriaExcelHelpers.js';
import { saveAs } from 'file-saver';

class ReportAdria extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			showMode: "all",
			mealJsonObj: null,
			adriaJsonObj: null,
			roomsHC1: null,
			roomsHC2: null,
			roomsHC3: null,
			intervalID: null,
			refreshIconRedYN: false,
			excelDateYear: 0,
			excelDateMonth: 0,
			excelDateDay: 0,
		};
	}

	componentDidMount() {
		
		var roomsHC1;
		var roomsHC2;
		var roomsHC3;
		
		var helpersObj = new ReportAdriaExcelHelpers();
		[roomsHC1,roomsHC2,roomsHC3] = helpersObj.getAllRoomsCornaro();

		this.setState({
			roomsHC1: roomsHC1,
			roomsHC2: roomsHC2,
			roomsHC3: roomsHC3,
		});
		
		var currentDateTime = new Date();
		var excelDateYear = currentDateTime.getFullYear();
		var excelDateMonth = currentDateTime.getMonth() + 1;
		var excelDateDay = currentDateTime.getDate();
		
		this.setState({
			excelDateYear: excelDateYear,
			excelDateMonth: excelDateMonth,
			excelDateDay: excelDateDay,
		});

		this.onRefreshData();

		this.intervalID = setInterval(() => {
			this.onRefreshAdriaData();
		}, 60*1000);
	}
	
	componentWillUnmount() {
		clearInterval(this.intervalID);
	}

	async serverDataConvertCsvToJson(fileUrl) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/dataconvertcsvtojson?url=" +  encodeURIComponent(fileUrl);
		
		var res = await fetch(url);
		var jsonObj = await res.json();
		
		return jsonObj;
	}
	
	async serverDataGetFileList(dashboardID) {

		var baseURLAPI = this.props.baseURLAPI;
		var folderUrl = "/dashboard/" + dashboardID + "/roomsWholeYear"
		var url = baseURLAPI + "/datagetfilelist?url=" +  encodeURIComponent(folderUrl);
		
		var jsonObj = null;
		
		try {
			var res = await fetch(url);
			jsonObj = await res.json();
		} catch (err) {
		}

		return jsonObj;
	}
	
	prevDate() {

		var excelDateYear = this.state.excelDateYear;
		var excelDateMonth = this.state.excelDateMonth;
		var excelDateDay = this.state.excelDateDay;
		
		var dateObj = new Date();
		dateObj.setFullYear(excelDateYear, excelDateMonth-1, excelDateDay);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec - 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var excelDateYear2 = dateObj2.getFullYear();
		var excelDateMonth2 = dateObj2.getMonth() + 1;
		var excelDateDay2 = dateObj2.getDate();

		this.setState({
			excelDateYear: excelDateYear2,
			excelDateMonth: excelDateMonth2,
			excelDateDay: excelDateDay2,
		});
	}
	
	nextDate() {

		var excelDateYear = this.state.excelDateYear;
		var excelDateMonth = this.state.excelDateMonth;
		var excelDateDay = this.state.excelDateDay;
		
		var dateObj = new Date();
		dateObj.setFullYear(excelDateYear, excelDateMonth-1, excelDateDay);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec + 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var excelDateYear2 = dateObj2.getFullYear();
		var excelDateMonth2 = dateObj2.getMonth() + 1;
		var excelDateDay2 = dateObj2.getDate();

		this.setState({
			excelDateYear: excelDateYear2,
			excelDateMonth: excelDateMonth2,
			excelDateDay: excelDateDay2,
		});
	}
		
	datePickerSetDate(dateObj) {

		var excelDateYear = dateObj.getFullYear();
		var excelDateMonth = dateObj.getMonth() + 1;
		var excelDateDay = dateObj.getDate();

		this.setState({
			excelDateYear: excelDateYear,
			excelDateMonth: excelDateMonth,
			excelDateDay: excelDateDay,
		});
	}
	
	getDateStringFromYMD(year, month, day) {
		var dateString;
		dateString = this.props.getTwoDigits(day) + "." + this.props.getTwoDigits(month) + "." + year + ".";
		return dateString;
	}
	
	getDateObjFromYMD(year, month, day) {

		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);

		return dateObj;
	}
	
	countRooms(allFloors) {

		var i;
		var j;
		var floorArray;
		var count = 0;

		for(i=0; i<allFloors.length; i++) {
			floorArray = allFloors[i];
			for(j=0; j<floorArray.length; j++) {
				count ++;
			}
		}
		
		return count;
	}
	
	findAdriaItemObj(roomNumber1) {

		var adriaJsonObj = this.state.adriaJsonObj;
		var data = adriaJsonObj.data;

		var i;
		var itemObj;
		var roomNumber2;
		
		for(i=0; i<data.length; i++) {
			itemObj = data[i];
			roomNumber2 = itemObj.roomNumber;
			if (roomNumber1 === roomNumber2) {
				return itemObj;
			}
		}
		
		return null;
	}
	
	findMealItemObj(roomNumber1) {

		var mealJsonObj = this.state.mealJsonObj;
		var data = mealJsonObj.data;

		var i;
		var itemObj;
		var roomNumber2;
		
		for(i=0; i<data.length; i++) {
			itemObj = data[i];
			roomNumber2 = itemObj.roomNumber;
			if (parseInt(roomNumber1) === parseInt(roomNumber2)) {
				return itemObj;
			}
		}
		
		return null;
	}

	// ne moze se sa https zvati http --- ne da chrome
	async onRefreshAdriaLocal() {

		// HC1 + HC2

		var urlBase = "http://192.168.1.131:8080";
		var usr = "admin";
		var psw = "13704280";
		var idHttpSessionId1 = "";
		
		idHttpSessionId1 = await makeLoginRequest(urlBase, usr, psw);
		var stateArray1 = await getStanjeXml(urlBase, idHttpSessionId1);
		if (stateArray1 === null) {
			return;
		}
		
		return;

		// HC3

		urlBase = "http://192.168.1.134:8080";
		usr = "admin";
		psw = "09500280";
		var idHttpSessionId2 = await makeLoginRequest(urlBase, usr, psw);

		var stateArray2 = await getStanjeXml(urlBase, idHttpSessionId2);
		if (stateArray2 === null) {
			return;
		}

		var stateArray = combineArrays(stateArray1, stateArray2);
		
	}
	
	async onRefreshAdriaData() {

		this.setState({
			refreshIconRedYN: true,
		});

		var dashboardID = this.props.dashboardID;

		var fileUrl = "/dashboard/" + dashboardID + "/roomsAdria/current.csv";
		var adriaJsonObj = await this.serverDataConvertCsvToJson(fileUrl);
		
		this.setState({
			refreshIconRedYN: false,
			adriaJsonObj: adriaJsonObj,
		});
	}
	
	async onRefreshData() {

		this.setState({
			mealJsonObj: null,
			adriaJsonObj: null,
		});

		var dashboardID = this.props.dashboardID;

		var fileUrl = "/dashboard/" + dashboardID + "/roomsMeal/current.csv";
		var mealJsonObj = await this.serverDataConvertCsvToJson(fileUrl);
		
		fileUrl = "/dashboard/" + dashboardID + "/roomsAdria/current.csv";
		var adriaJsonObj = await this.serverDataConvertCsvToJson(fileUrl);
		
		this.setState({
			mealJsonObj: mealJsonObj,
			adriaJsonObj: adriaJsonObj,
		});
	}

	renderHeader() {

		var mealJsonObj = this.state.mealJsonObj;
		var adriaJsonObj = this.state.adriaJsonObj;
		if ((mealJsonObj === null) || (adriaJsonObj === null)) {
			return;
		}

		var headerObj = mealJsonObj.header;
		var unixTimeSec = headerObj.unixTimeSec;
		var timeString1 = this.props.getDateTimeStringFromUnixTimeSec(unixTimeSec);

		headerObj = adriaJsonObj.header;
		unixTimeSec = headerObj.unixTimeSec;
		var timeString2 = this.props.getDateTimeStringFromUnixTimeSec(unixTimeSec);
		
		var refreshIconRedYN = this.state.refreshIconRedYN;
		var iconColor = "green";
		if (refreshIconRedYN) {
			iconColor = "red";
		}

		return (
			<center>
				<div className="ReportAdriaHeaderContainer">
					<div className="ReportAdriaHeaderOneOption">Milenij: {timeString1}</div>
					<div className="ReportAdriaHeaderMiddleOption" onClick={() => this.onRefreshData()}>
						<IoMdRefresh style={{ color: iconColor, width: "25px", height: "25px"}}/>
					</div>
					<div className="ReportAdriaHeaderOneOption">Adria: {timeString2}</div>
				</div>
			</center>
		);
	}

	onAllClicked() {		
		this.setState({showMode: "all"});
	}
	
	onVacantClicked() {
		this.setState({showMode: "vacant"});
	}
	
	onACClicked() {
		this.setState({showMode: "ac"});
	}
	
	onStaffClicked() {		
		this.setState({showMode: "staff"});
	}
	
	onError1Clicked() {
		this.setState({showMode: "error1"});
	}
	
	onError2Clicked() {
		this.setState({showMode: "error2"});
	}
	
	renderFilter() {
		
		var showMode = this.state.showMode;
		
		var classNameAll = "ReportAdriaFilterOneOption";
		if (showMode === "all") {
			classNameAll = "ReportAdriaFilterSelectedOption";
		}
		
		var classNameVacant = "ReportAdriaFilterOneOption";
		if (showMode === "vacant") {
			classNameVacant = "ReportAdriaFilterSelectedOption";
		}
		
		var classNameAC = "ReportAdriaFilterOneOption";
		if (showMode === "ac") {
			classNameAC = "ReportAdriaFilterSelectedOption";
		}
		
		var classNameStaff = "ReportAdriaFilterOneOption";
		if (showMode === "staff") {
			classNameStaff = "ReportAdriaFilterSelectedOption";
		}
		
		var classNameError1 = "ReportAdriaFilterOneOption";
		if (showMode === "error1") {
			classNameError1 = "ReportAdriaFilterSelectedOption";
		}
		
		var classNameError2 = "ReportAdriaFilterOneOption";
		if (showMode === "error2") {
			classNameError2 = "ReportAdriaFilterSelectedOption";
		}
		
		return(
			<center>
				<div className="ReportAdriaFilterContainer">
					<div className={classNameAll} onClick={() => this.onAllClicked()}>{this.props.getLang(ReportLang, "all")}</div> 
					<div className="ReportAdriaFilterOneSeparator">-</div>
					<div className={classNameVacant} onClick={() => this.onVacantClicked()}>{this.props.getLang(ReportLang, "vacant")}</div> 
					<div className="ReportAdriaFilterOneSeparator">-</div>
					<div className={classNameAC} onClick={() => this.onACClicked()}>{this.props.getLang(ReportLang, "ac")}</div> 
					<div className="ReportAdriaFilterOneSeparator">-</div>
					<div className={classNameStaff} onClick={() => this.onStaffClicked()}>{this.props.getLang(ReportLang, "staff")}</div> 
					<div className="ReportAdriaFilterOneSeparator">-</div>
					<div className={classNameError1} onClick={() => this.onError1Clicked()}>{this.props.getLang(ReportLang, "error1")}</div> 
					<div className="ReportAdriaFilterOneSeparator">-</div>
					<div className={classNameError2} onClick={() => this.onError2Clicked()}>{this.props.getLang(ReportLang, "error2")}</div> 
				</div>
			</center>
		);
	}

	// addr,type,statusi,roomNumber,roomStatus,setTemperature,roomTemperature,point,cardPresent,cardName,door,window,staff,ac
	
	renderOneRoom(buildingIndex, floorIndex, roomIndex, roomNumber, lineIndex) {

		var adriaItemObj1 = null;
		var adriaItemObj2 = null;
		var mealItemObj;
		var key = "roomkey-" + buildingIndex + "-" + floorIndex + "-" + roomIndex;

		adriaItemObj1 = this.findAdriaItemObj(roomNumber.toString());
		adriaItemObj2 = this.findAdriaItemObj(roomNumber + "-1");
		//if ((roomNumber === 405) || (roomNumber === 406) || (roomNumber === 521) || (roomNumber === 525) || (roomNumber === 245)) {
		//if ((roomNumber === 430) || (roomNumber === 441)) {
		//}
		mealItemObj = this.findMealItemObj(roomNumber);

		var mealYN = false;
		var vacantUntil = "";
		if (mealItemObj !== null) {
			mealYN = true;
		}
		
		if (adriaItemObj1 === null) {
			console.log("roomNumber = " + roomNumber);
			console.log("adriaItemObj1 is NULL");
			return [null, 0, lineIndex, false, false];
		}

		var point = adriaItemObj1.point;
		if (point === " ") {
			point = "";
		}
		var tempsString = adriaItemObj1.setTemperature + " / " + adriaItemObj1.roomTemperature + point;
		
		var roomStatus = adriaItemObj1.roomStatus;
		var cardName = adriaItemObj1.cardName;
		var door = adriaItemObj1.door;
		var window = adriaItemObj1.window;
		var ac = adriaItemObj1.ac;
		var staff = adriaItemObj1.staff;
		//var ignoreCard = adriaItemObj1.ignoreCard;
		var ac2 = "";
		var tempsString2 = "";

		if (adriaItemObj2 !== null) {
			ac2 = adriaItemObj2.ac;
			tempsString2 = adriaItemObj2.setTemperature + " / " + adriaItemObj2.roomTemperature;
		}

		var tempsClassName = "ReportAdriaTempsItem";
		if ((ac === "B") || (ac === "C") || (ac === "D") || (ac2 === "B") || (ac2 === "C") || (ac2 === "D")) {
			var diffTemp = adriaItemObj1.roomTemperature - adriaItemObj1.setTemperature; 
			if (diffTemp >= 2) {
				if (adriaItemObj1.roomTemperature >= 23) {
					tempsClassName = "ReportAdriaTempsItemRed";
				} else {
					if (adriaItemObj1.roomTemperature >= 21) {
						tempsClassName = "ReportAdriaTempsItemOrange";
					}
				}
			}
			if (adriaItemObj2 !== null) {
				if (tempsClassName !== "ReportAdriaTempsItemRed") {
					diffTemp = adriaItemObj2.roomTemperature - adriaItemObj2.setTemperature;
					if (diffTemp >= 2) {
						if (adriaItemObj2.roomTemperature >= 23) {
							tempsClassName = "ReportAdriaTempsItemRed";
						} else {
							if (adriaItemObj2.roomTemperature >= 21) {
								tempsClassName = "ReportAdriaTempsItemOrange";
							}
						}
					}
				}
			}
		}
		
		var rented = 0;
		var rentedString = "";
		var inRoom = cardName;

		if (roomStatus === "rented_guest_not_in_room") {
			rented = 1;
			rentedString = "Yes";
			if (!mealYN) {
				rentedString = "Yes / Vacant";
			}
		}
		if (roomStatus === "rented_guest_in_room") {
			rented = 1;
			rentedString = "Yes";
			inRoom = "Guest";
			if (!mealYN) {
				rentedString = "Yes / Vacant";
			}
		}
		if (roomStatus === "sos1") {
			rented = 0;
			rentedString = "SOS1";
		}
		if (roomStatus === "sos2") {
			rented = 0;
			rentedString = "SOS2";
		}

		var error1YN = false;
		var error2YN = false;

		if (staff.toString() === "0") {
			if (!mealYN && (rented === 1)) {
				rentedString = "ERROR 1 - Milenij No, Adria Yes";
				rented = -1;
				error1YN = true;
			}
			if (mealYN && (rented === 0)) {
				rentedString = "ERROR 2 - Milenij Yes, Adria No";
				rented = -2;
				error2YN = true;
			}
		}
		
		var showMode = this.state.showMode;
		
		if (showMode === "vacant") {
			if (mealYN || (roomNumber === 561)) {
				return [null, roomNumber, lineIndex, error1YN, error2YN];
			}
		}
		
		var acUnit1YN = false;
		var acUnit2YN = false;
		if ((ac === "B") || (ac === "C") || (ac === "D")) {
			acUnit1YN = true;
		}
		if ((ac2 === "B") || (ac2 === "C") || (ac2 === "D")) {
			acUnit2YN = true;
		}

		if (showMode === "ac") {
			if (adriaItemObj2 !== null) {
				if (!acUnit1YN && !acUnit2YN) {
					return [null, roomNumber, lineIndex, error1YN, error2YN];
				}
			} else {
				if (!acUnit1YN) {
					return [null, roomNumber, lineIndex, error1YN, error2YN];
				}
			}
		}

		if (showMode === "staff") {
			if (staff.toString() === "0") {
				return [null, roomNumber, lineIndex, error1YN, error2YN];
			}
		}
		
		if (showMode === "error1") {
			if (!error1YN || (roomNumber === 561)) {
				return [null, roomNumber, lineIndex, error1YN, error2YN];
			}
		}

		if (showMode === "error2") {
			if (!error2YN) {
				return [null, roomNumber, lineIndex, error1YN, error2YN];
			}
		}
		
		var doorString = "";
		var windowString = "";
		
		if (roomNumber.toString() === "237") {
			//console.log(roomNumber + " - window = " + window);
		}

		if ((buildingIndex === 0) || (buildingIndex === 1)) {
			if (door === "0") {
				doorString = ""; // closed
			}
			if (door === "1") {
				doorString = "open";
			}
			if (door === "2") {
				doorString = "alarm";
			}
			if (window.toString() === "0") {
				windowString = ""; // closed
			}
			if (window.toString() === "1") {
				windowString = "open";
			}
			if (window.toString() === "2") {
				windowString = "alarm";
			}
		} else {
			if (door === "1") {
				doorString = "open";
			}
			if (door === "2") {
				doorString = "";  // closed
			}
			if (door === "3") {
				doorString = "alarm";
			}
			if (window.toString() === "1") {
				windowString = "open";
			}
			if (window.toString() === "2") {
				windowString = ""; // closed
			}
			if (window.toString() === "3") {
				windowString = "alarm";
			}
		}

		if (inRoom === null) {
			inRoom = "";
		}

		if (roomNumber === 561) {
			rentedString = "";
			rented = 0;
			error1YN = false;
			error2YN = false;
			inRoom = "";
			roomNumber = "Priuli";
		}
		
		var trClassName = "ReportTableLine1";
		if (lineIndex % 2 === 0) {
			trClassName = "ReportTableLine2";
		}

		var jsxCode = (
			<tr className={trClassName} key={key}>
				<td className="ReportAdriaRoomNumberItem">{roomNumber}</td>
				<td className="ReportAdriaRentedItem">{rentedString}</td>
				<td className="ReportAdriaInRoomItem">{inRoom}</td>
				<td className={tempsClassName}>{tempsString}</td>
				<td className="ReportAdriaACItem">{ac}</td>
				<td className="ReportAdriaDoorItem">{doorString}</td>
				<td className="ReportAdriaWindowItem">{windowString}</td>
			</tr>
		);

		if (adriaItemObj2 !== null) {
			jsxCode = (
				<tr className={trClassName} key={key}>
					<td className="ReportAdriaRoomNumberItem">{roomNumber}</td>
					<td className="ReportAdriaRentedItem">{rentedString}</td>
					<td className="ReportAdriaInRoomItem">{inRoom}</td>
					<td className={tempsClassName}>{tempsString}<br/>{tempsString2}</td>
					<td className="ReportAdriaACItem">{ac}<br/>{ac2}</td>
					<td className="ReportAdriaDoorItem">{doorString}</td>
					<td className="ReportAdriaWindowItem">{windowString}</td>
				</tr>
			);		
		}
		
		lineIndex ++;

		return [jsxCode, roomNumber, lineIndex, error1YN, error2YN];
	}
	
	renderOneFloor(buildingIndex, floorIndex, floorArray, lineIndex, error1Array, error2Array) {

		var i;
		var roomNumber;
		var error1YN;
		var error2YN;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<floorArray.length; i++) {
			roomNumber = floorArray[i];
			[jsxCode, roomNumber, lineIndex, error1YN, error2YN] = this.renderOneRoom(buildingIndex, floorIndex, i, roomNumber, lineIndex);
			jsxArray.push(jsxCode);
			if (error1YN) {
				error1Array.push(roomNumber);
			}
			if (error2YN) {
				error2Array.push(roomNumber);
			}
		}

		if ((buildingIndex === 1) && (floorIndex === 5)) {
			roomNumber = 561;
			i = i + 1;
			[jsxCode, roomNumber, lineIndex, error1YN, error2YN] = this.renderOneRoom(buildingIndex, floorIndex, i, roomNumber, lineIndex);
			jsxArray.push(jsxCode);
		}

		return [jsxArray, lineIndex, error1Array, error2Array];
	}

	renderOneBuidling(buildingIndex, buildingName, buildingArray, error1Array, error2Array) {
		
		var i;
		var key = "buildingkey-" + buildingIndex;
		var floorArray;
		var jsxCode;
		var jsxArray = [];
		var lineIndex = 0;
		
		for(i=0; i<buildingArray.length; i++) {
			floorArray = buildingArray[i];
			[jsxCode, lineIndex, error1Array, error2Array] = this.renderOneFloor(buildingIndex, i, floorArray, lineIndex, error1Array, error2Array);
			jsxArray.push(jsxCode);
		}
		
		jsxCode = (
			<div key={key}>
				<div className="ReportAdriaBuildingName">{buildingName}</div>
				<div style={{height: "20px"}}></div>
				<div style={{width: "95vw", textAlign: "center"}}>
					<table style={{margin: "0 auto"}}>
						<thead>
							<tr>
								<th className="ReportAdriaRoomNumberHeader">{this.props.getLang(ReportLang, "roomNumber")}</th>
								<th className="ReportAdriaRentedHeader">{this.props.getLang(ReportLang, "rented")}</th>
								<th className="ReportAdriaInRoomHeader">{this.props.getLang(ReportLang, "inRoom")}</th>
								<th className="ReportAdriaTempsHeader">{this.props.getLang(ReportLang, "temps")}</th>
								<th className="ReportAdriaACHeader">{this.props.getLang(ReportLang, "ac")}</th>
								<th className="ReportAdriaDoorHeader">{this.props.getLang(ReportLang, "door")}</th>
								<th className="ReportAdriaWindowHeader">{this.props.getLang(ReportLang, "window")}</th>
							</tr>
						</thead>
						<tbody>
							{jsxArray}
						</tbody>
					</table>
				</div>
				<div style={{height: "20px"}}></div>
			</div>
		);
		
		return [jsxCode, error1Array, error2Array];
	}
	
	renderOneErrorString(errorArray, error1YN) {
		
		var i;
		var roomNumber;
		var string2 = "";

		var key = "key-error2";
		var string1 = "Milenij DA, Adria NE - ove sobe:";
		if (error1YN) {
			key = "key-error1";
			string1 = "Milenij NE, Adria DA - ove sobe:";			
		}
		
		roomNumber = errorArray[0];
		string2 = roomNumber;
		for(i=1; i<errorArray.length; i++) {
			roomNumber = errorArray[i];
			string2 = string2 + ", " + roomNumber;
		}
		
		return (
			<div key={key}>
				{string1} {string2}
			</div>
		);
	}
	
	renderACLegend() {
		return (
		<center>
			<div>
				<div className="ReportAdriaACLegend">
					Temp (C) = X / Y - X je ciljana temperatura, a Y je stvarna temperatura
				</div>
				<div style={{height: "20px"}}></div>
				<div className="ReportAdriaACLegend">
					A - klima se ugasila sama jer je dosegla temperaturu<br/>
					B - klima radi na 1<br/>
					C - klima radi na 2<br/>
					D - klima radi na 3<br/>
					@ - gost izgasio klimu sa tipkovnicom
				</div>
				<div style={{height: "20px"}}></div>
			</div>
		</center>
		);
	}

	renderAllBuildings() {

		var mealJsonObj = this.state.mealJsonObj;
		var adriaJsonObj = this.state.adriaJsonObj;
		if ((mealJsonObj === null) || (adriaJsonObj === null)) {
			return;
		}
		
		var roomsHC1 = this.state.roomsHC1;
		var roomsHC2 = this.state.roomsHC2;
		var roomsHC3 = this.state.roomsHC3;
		if ((roomsHC1 === null) || (roomsHC2 === null) || (roomsHC3 === null)) {
			return;
		}
		
		var jsxCode;
		var jsxArray = [];
		var error1Array = [];
		var error2Array = [];

		[jsxCode, error1Array, error2Array] = this.renderOneBuidling(0, "HC1", roomsHC1, error1Array, error2Array);
		jsxArray.push(jsxCode);
		
		[jsxCode, error1Array, error2Array] = this.renderOneBuidling(1, "HC2", roomsHC2, error1Array, error2Array);
		jsxArray.push(jsxCode);

		[jsxCode, error1Array, error2Array] = this.renderOneBuidling(2, "HC3", roomsHC3, error1Array, error2Array);
		jsxArray.push(jsxCode);
		
		jsxCode = this.renderACLegend();
		jsxArray.push(jsxCode);
		
		if (error1Array.length > 0) {
			jsxCode = this.renderOneErrorString(error1Array, true);
			jsxArray.push(jsxCode);
		}
		
		if (error2Array.length > 0) {
			jsxCode = this.renderOneErrorString(error2Array, false);
			jsxArray.push(jsxCode);
		}
		
		return jsxArray;
	}
	
	async onClickDownloadExcel() {

		var toastString = this.props.getLang(ReportLang, "downloadExcelStarted");
		this.props.showToast(toastString);

		var year = this.state.excelDateYear;
		var month = this.state.excelDateMonth;
		var day = this.state.excelDateDay;

		var helpersObj = new ReportAdriaExcelHelpers();
		helpersObj.baseURLAPI = this.props.baseURLAPI;
		var excelBuffer = await helpersObj.createExcel(year, month, day);
		
		if (excelBuffer === null) {
			var toastString = this.props.getLang(ReportLang, "noDataFound");
			this.props.showToast(toastString);
			return;
		}

		var filename = "Cornaro Adria " + year + "-" + this.props.getTwoDigits(month) + "-" + this.props.getTwoDigits(day) + ".xlsx";
		var blob = new Blob([excelBuffer], { type: 'application/octet-stream' });	
		saveAs(blob, filename);
	}
	
	renderFooter() {
		
		var url1 = "http://192.168.1.131:8080";
		var url2 = "http://192.168.1.134:8080";
		
		var dateObj = this.getDateObjFromYMD(this.state.excelDateYear, this.state.excelDateMonth, this.state.excelDateDay);

		return (
			<center>
				<div>
					<div><a href={url1} target="_blank" rel="noopener noreferrer">{url1}</a></div>
					<div><a href={url2} target="_blank" rel="noopener noreferrer">{url2}</a></div>
				</div>
				<div style={{height: "20px"}}></div>
				<div className="ReportAdriaDateContainer">
					<div className="ReportAdriaDatePrev" onClick={() => this.prevDate()}>&lt;&lt;</div>
					<DatePicker 
						className="ReportAdriaDateString" 
						selected={dateObj} onChange={(date) => this.datePickerSetDate(date)} 
						dateFormat="dd.MM.yyyy."
					/>
					<div className="ReportAdriaDateNext" onClick={() => this.nextDate()}>&gt;&gt;</div>
				</div>
				<div>
					<button className="ViewSaveButton" onClick={() => this.onClickDownloadExcel()}>{this.props.getLang(ReportLang, "downloadExcel")}</button>&nbsp;&nbsp;
				</div>
			</center>
		);
	}

	render() {
		return (
			<div>
				<div style={{height: "20px"}}></div>
				{this.renderHeader()}
				<div style={{height: "10px"}}></div>
				{this.renderFilter()}
				<div style={{height: "20px"}}></div>
				{this.renderAllBuildings()}
				<div style={{height: "20px"}}></div>
				{this.renderFooter()}
				<div style={{height: "50px"}}></div>
			</div>
		);
	}
}

export default ReportAdria;

